import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import Popup from 'components/popups/Popup'
import React from 'react'

interface PaymentConfirmationPopupProps {
  isLoading: boolean
  callback: basic.BasicFunc
}

const PaymentConfirmationPopup: React.FC<PaymentConfirmationPopupProps> = ({ isLoading, callback }) => {
  const { t } = useTranslation('payment')
  return (
    <Popup>
      <div className='paymentConfirmation__popup'>
        <div className='popup__title'>
          <div>{t('confirmTransferTitle')}</div>
          <div>{t('confirmTransferDescription')}</div>
        </div>
        <div className='popup__buttons'>
          <ArrowBtn
            enlarged
            isLoading={isLoading}
            text={t('confirm')}
            action={callback}
          />
          <BackBtn text={t('cancel')} />
        </div>
      </div>
    </Popup>
  )
}

export default PaymentConfirmationPopup